<template>
  <v-app v-if="($route.name !== 'Login' && $route.name !== 'SSOLogin' && $route.name !== 'ComeIn')">
    <default-bar />

    <default-drawer />

    <default-view />

    <!-- <default-footer /> -->

    <default-settings />
  </v-app>
  <v-app v-else>
    <router-view :key="$route.path" />
  </v-app>
</template>

<script>
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultLayout',

    components: {
      DefaultBar: () => import(
        /* webpackChunkName: "default-app-bar" */
        './AppBar'
      ),
      DefaultDrawer: () => import(
        /* webpackChunkName: "default-drawer" */
        './Drawer'
      ),
      // DefaultFooter: () => import(
      //   /* webpackChunkName: "default-footer" */
      //   './Footer'
      // ),
      DefaultSettings: () => import(
        /* webpackChunkName: "default-settings" */
        './Settings'
      ),
      DefaultView: () => import(
        /* webpackChunkName: "default-view" */
        './View'
      ),
    },

    computed: {
      ...sync('user', [
        'dark',
        'drawer',
        'gradients',
      ]),
      info: get('user/info'),
    },

    // async created () {
    //   console.log(this.dark)
    //   console.log(this.drawer)
    //   console.log(this.gradients)
    // },
  }
</script>
